import {
    DELETE_LOYALTY_IMAGE,
    DELETE_PROMOTION_SUCCESS,
    GET_LOYALTY,
    SAVE_PROMOTION_SUCCESS
} from "../../../actions/types";

const INITIAL_STATE = {

};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_LOYALTY:
            return action.payload;
        case SAVE_PROMOTION_SUCCESS:
            return [...state, action.payload];
        case DELETE_LOYALTY_IMAGE:
            return {...state};
        case DELETE_PROMOTION_SUCCESS:
            return state;
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/restaurants/loyalty/LoyaltyReducer.js